<div class="skip-link">
    <a [href]="[skip2main]" i18n="@@skip-link-main">Skip to main content</a>
    &nbsp;
    <a [href]="[skip2footer]" i18n="@@skip-link-footer">or footer</a>
</div>

<div class="body__inner">
    <app-toolbar></app-toolbar>

    <div class="main-content">
        <riege-loading></riege-loading>
        <router-outlet></router-outlet>
    </div>

    <app-footer></app-footer>

    <app-scroll-top></app-scroll-top>
</div>
